export const GET_RESOURCE_ALLOCATIONS_LIST = 'VARUNA.GET_RESOURCE_ALLOCATIONS_LIST'
export const SEARCH_RESOURCE_ALLOCATIONS = 'VARUNA.SEARCH_RESOURCE_ALLOCATIONS'
export const SELECT_RESOURCE_ALLOCATION = 'VARUNA.SELECT_RESOURCE_ALLOCATION'
export const GET_RESOURCE_ALLOCATION_CALENDAR = 'VARUNA.GET_RESOURCE_ALLOCATION_CALENDAR'
